module.exports = __webpack_public_path__ + "static/media/stripe.54e13e6a.svg";